import getObjectValue from './getObjectValue';
import _ from 'lodash';

export default (formikProps, id, index) => {

	let values;
	if (id === undefined) {
		values = formikProps.values
	} else {
		values = getObjectValue(id, formikProps.values)
	}
	values = _.cloneDeep(values);
	values.splice(index, 1)
	formikProps.setFieldValue(id, values)

	let touched = getObjectValue(id, formikProps.touched)

	if (typeof touched === 'boolean') {
		formikProps.setFieldTouched(id, [])
	} else if (touched) {
		let newTouched = [...touched]
		newTouched.splice(index, 1)
		formikProps.setFieldTouched(id, newTouched)
	}
}